import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { useGetParametro } from '@/shared/actions/erp';
import { useCheckPermissions, useLoaders } from '@/shared/hooks';
import { SaveParametro } from './../../shared/components';
import { ROUTER_PATHS } from '@/shared';

export type UpdateParametroPageProps = {};

const UpdateParametroPage: React.FC<UpdateParametroPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_parametro);
  const returnUrlParametrosPage =
    ROUTER_PATHS.administration.systemParametersNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetParametro(id!);
  useLoaders(isLoading || isRefetching);

  if (isLoading) return null;
  if (!data?.data?.id_parametro)
    return <Navigate to={returnUrlParametrosPage} />;

  return (
    <SaveParametro title="Editar Parámetro del Sistema" parametro={data.data} />
  );
};

export default UpdateParametroPage;
